// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import cn from 'classnames';
var Navbar_toggle = props => {
  var on_toggle = props.on_toggle,
    toggled = props.toggled;
  var cls = cn('navbar-toggle', toggled && 'active');
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cls,
    "aria-label": "Toggle",
    onClick: on_toggle
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-bar"
  }), /*#__PURE__*/React.createElement("span", {
    className: "icon-bar"
  }), /*#__PURE__*/React.createElement("span", {
    className: "icon-bar"
  }), /*#__PURE__*/React.createElement("span", {
    className: "icon-bar"
  }));
};
export { Navbar_toggle };